import React, { useState, useRef } from "react";
import { Box, Button, HStack, Text, Tooltip } from "@chakra-ui/react";
import ReactPlayer from "react-player";

const playlist = [
    { title: "", url: "https://youtu.be/e-63LbM89MM" },
    { title: "", url: "https://youtu.be/5i-2rgkp_Z4?si=zm2hSMk__vMQlSc4" },
    { title: "", url: "https://youtu.be/Ci3qirYbrQA?si=Ozo95fYmjcWwXABc" },
];

const MusicPlayer = ({ onPlayingChange }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isShuffled, setIsShuffled] = useState(false);
    const [shuffledIndices, setShuffledIndices] = useState([]);
    const playerRef = useRef(null);

    const getNextIndex = () => {
        if (isShuffled) {
            const currentShufflePos = shuffledIndices.indexOf(currentIndex);
            const nextShufflePos = (currentShufflePos + 1) % shuffledIndices.length;
            return shuffledIndices[nextShufflePos];
        }
        return (currentIndex + 1) % playlist.length;
    };

    const getPrevIndex = () => {
        if (isShuffled) {
            const currentShufflePos = shuffledIndices.indexOf(currentIndex);
            const prevShufflePos = (currentShufflePos - 1 + shuffledIndices.length) % shuffledIndices.length;
            return shuffledIndices[prevShufflePos];
        }
        return (currentIndex - 1 + playlist.length) % playlist.length;
    };

    const handleNext = () => {
        setCurrentIndex(getNextIndex());
    };

    const handlePrev = () => {
        setCurrentIndex(getPrevIndex());
    };

    const handlePlayPause = () => {
        setIsPlaying(!isPlaying);
    };

    const handleShuffle = () => {
        // Pick a random video different from current
        let randomIndex;
        do {
            randomIndex = Math.floor(Math.random() * playlist.length);
        } while (randomIndex === currentIndex && playlist.length > 1);
        setCurrentIndex(randomIndex);

        if (!isShuffled) {
            const indices = [...Array(playlist.length).keys()];
            for (let i = indices.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [indices[i], indices[j]] = [indices[j], indices[i]];
            }
            setShuffledIndices(indices);
        }
        setIsShuffled(!isShuffled);
    };

    const handleEnded = () => {
        handleNext();
    };

    const handlePlay = () => {
        setIsPlaying(true);
        onPlayingChange(true);
    };

    const handlePause = () => {
        setIsPlaying(false);
        onPlayingChange(false);
    };

    return (
        <Box>
            <ReactPlayer
                ref={playerRef}
                width="340px"
                height="140px"
                src={playlist[currentIndex].url}
                playing={isPlaying}
                onPlay={handlePlay}
                onPause={handlePause}
                onEnded={handleEnded}
            />
            <HStack justify="center" mt={2} spacing={1}>
                <Tooltip label="Shuffle">
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={handleShuffle}
                        color={isShuffled ? "green.300" : "gray.100"}
                        _hover={{ color: "green.300" }}
                    >
                        <i className="ri-shuffle-line ri-lg"></i>
                    </Button>
                </Tooltip>
                <Tooltip label="Previous">
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={handlePrev}
                        color="gray.100"
                        _hover={{ color: "blue.300" }}
                    >
                        <i className="ri-skip-back-line ri-lg"></i>
                    </Button>
                </Tooltip>
                <Tooltip label={isPlaying ? "Pause" : "Play"}>
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={handlePlayPause}
                        color="gray.100"
                        _hover={{ color: "blue.300" }}
                    >
                        <i className={isPlaying ? "ri-pause-line ri-lg" : "ri-play-line ri-lg"}></i>
                    </Button>
                </Tooltip>
                <Tooltip label="Next">
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={handleNext}
                        color="gray.100"
                        _hover={{ color: "blue.300" }}
                    >
                        <i className="ri-skip-forward-line ri-lg"></i>
                    </Button>
                </Tooltip>
            </HStack>
            <Text fontSize="xs" mt={1} textAlign="center" color="gray.500">
                {currentIndex + 1}/{playlist.length}{playlist[currentIndex].title && ":"} {playlist[currentIndex].title}
            </Text>
        </Box>
    );
};

export default MusicPlayer;
